var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "boss-jobtype-item margin-bottom-05" }, [
    _c(
      "div",
      { staticClass: "boss-label display-flex" },
      [
        _vm.canAccordion
          ? [
              !_vm.showCategoryItems
                ? _c(
                    "span",
                    {
                      staticClass: "pega-modal-accordion",
                      attrs: { "data-test": "open-category" },
                      on: { click: _vm.switchShowCategory },
                    },
                    [_vm._v("+")]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "pega-modal-accordion",
                      attrs: { "data-test": "close-category" },
                      on: { click: _vm.switchShowCategory },
                    },
                    [_vm._v("–")]
                  ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("label", { staticClass: "pega-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.all,
                expression: "all",
              },
            ],
            staticClass: "boss-input-check",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.all)
                ? _vm._i(_vm.all, null) > -1
                : _vm.all,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.all,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.all = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.all = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.all = $$c
                }
              },
            },
          }),
          _vm._v(_vm._s(_vm.category.name) + "\n    "),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCategoryItems || !_vm.canAccordion,
            expression: "showCategoryItems || !canAccordion",
          },
        ],
        staticClass: "boss-jobtype-details",
        attrs: { "data-test": "category-items" },
      },
      _vm._l(_vm.category.children, function (categoryItem, index) {
        return _c("select-modal-contents-category-item", {
          key: index,
          attrs: {
            "category-item": categoryItem,
            "category-item-data-map": _vm.categoryDataMap[categoryItem.id],
            "experience-range-options": _vm.experienceRangeOptions,
            "default-experience-id": _vm.defaultExperienceId,
          },
          on: { "update-category-item": _vm.updateCategoryItem },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }